export default [
  {
    path: "/deep/profile",
    name: "deepProfile",
    component: () => import(
      /*webpackChunkName:'DeepProfile'*/
      "@/views/deep/DeepProfile.vue"),
    meta: {},
  },
  {
    path: "/deep/profile-schedule",
    name: "deepProfileSchedule",
    component: () => import(
      /*webpackChunkName:'DeepProfile'*/
      "@/views/deep/DeepProfileSchedule.vue"),
    meta: {},
  },
  {
    path: "/deep/task-result",
    name: "deepTaskResult",
    component: () => import(
      /*webpackChunkName:'DeepTaskResult'*/
      "@/views/deep/DeepTaskResult.vue"),
    meta: {},
  },
  
  {
    path: "/wide/profile",
    name: "wideProfile",
    component: () => import(
      /*webpackChunkName:'wideProfile'*/
      "@/views/wide/WideProfile.vue"),
    meta: {},
  },
  {
    path: "/wide/profile-schedule",
    name: "wideProfileSchedule",
    component: () => import(
      /*webpackChunkName:'wideProfileSchedule'*/
      "@/views/wide/WideProfileSchedule.vue"),
    meta: {},
  },
]